import * as React from "react";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import singleClickCheckout from "../../../assets/img/features/single_click_checkout.gif";
// import singleClickCheckout from "../../../assets/img/features/single-click-checkout.gif";

export default function SingleClickCheckout() {
  return (
    <Box
      sx={{
        width: "100%",
        padding:  {xs:"2rem 0", md:"10rem 0"},
        // backgroundColor: 'primary.dark',
        background: "linear-gradient(0deg, rgba(244, 249, 255, 0) 0%, #F4F9FF 100%)",
      }}
    >
      <Box
        sx={{
          height: "inherit",
          width: "inherit",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-evenly",
          alignItems: "center"
        }}
      >
        <Box sx={{ width: { sx: "90vw", md: "40vw", padding: "2rem" } }}>
          <Typography variant="h3" gutterBottom fontWeight={800}>
            Single click checkout that drives highest conversion
          </Typography>
          <Typography variant="h5" gutterBottom fontWeight={300} fontSize="1.2rem">
            Apik's true single click checkout drives highest conversion for your brand. Reduce customer acquistion costs by converting visitors from instagram/facebook to paying customers. 
            Apik's smart Payment solution auto-selects the most optimal payment method for customer. Removes cognitive load of repetitively asking for payment methods from customers to choose from.  
          </Typography>
        </Box>
        <Box>
          <img src={singleClickCheckout} alt="loading..." height={600} width={320} style={{borderRadius: '16px'}}/>
        </Box>
      </Box>
    </Box>
  );
}
